<template>
  <VHover>
    <VLayout
      slot-scope="{ hover }"
      column
      text-xs-center
    >
      <VFlex
        xs12
      >
        <VLayout
          fill-height
          align-center
          justify-center
          ma-0
        >
          <VImg
            :src="avatarImg"
            :lazy-src="require('@/assets/sndle-avatar-default.png')"
            class="avatar"
            max-width="120px"
            max-height="120px"
            aspect-ratio="1.0"
            contain
          >
            <VLayout
              slot="placeholder"
              fill-height
              align-center
              justify-center
              ma-0
            >
              <VProgressCircular
                indeterminate
                color="grey lighten-5"
              />
            </VLayout>
          </VImg>
        </VLayout>
      </VFlex>

      <VExpandTransition>
        <VFlex
          v-show="setHoverStatus(hover) || hoverStatus"
          xs12
        >
          <VBtn
            id="pickAvatar"
            small
            color="primary"
          >
            Select a new image
          </VBtn>
        </VFlex>
      </VExpandTransition>
      <AvatarCropper
        ref="avatarCropper"
        :labels="cropperLabels"
        :upload-handler="uploadHandler"
        trigger="#pickAvatar"
        :output-options="outputOptions"
      />
    </VLayout>
  </VHover>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper'
import { mapActions } from 'vuex'

export default {
  components: { AvatarCropper },
  props: {
    avatarImg: {
      type: String,
      default: undefined
    },
    contactId: {
      type: String,
      default: ''
    },
    contactIndex: {
      type: Number,
      default: -1
    },
    avatarPlaceholder: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      cropperLabels: {
        submit: 'Submit',
        cancel: 'Cancel'
      },
      outputOptions: {
        type: Object,
        default () {
          return {
            width: 512,
            height: 512
          }
        }
      },
      hoverStatus: false,
      isResetNeeded: false
    }
  },
  methods: {
    setIsResetNeeded (val) {
      this.isResetNeeded = val
    },
    setHoverStatus (val) {
      if (this.isResetNeeded) {
        this.hoverStatus = false
        if (!val) this.isResetNeeded = false
        return
      }
      this.hoverStatus = val
    },
    uploadHandler (cropper) {
      // call upload action here
      cropper.getCroppedCanvas(this.outputOptions).toBlob((blob) => {
        blob.name = this.$refs.avatarCropper.filename
        const uploadData = {
          id: this.contactId,
          file: blob
        }
        this.setContactLoadingStatus({ val: true })
        this.setContactLoadingMessage({ message: 'Uploading the image. Please wait...' })
        this.$store.dispatch('contact/uploadContactAvatarImg', { uploadData, index: this.contactIndex })
        this.$emit('uploading')
      })
      this.isResetNeeded = true
    },
    ...mapActions({
      setContactLoadingStatus: 'contact/setLoadingStatus',
      setContactLoadingMessage: 'contact/setStatusMessage'
    })
  }
}
</script>

<style scoped >
  .avatar {
    vertical-align: middle;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -khtml-border-radius: 50%;
    border: 3px solid #fff;
    margin-top: 10px;
    object-fit: fill;
  }
</style>
